import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/companiesActions'
import * as api from '../api/company'

function* fetchCompanies(action) {
  try {
    const payload = yield call(api.getCompaniesList, action)
    yield put({ type: constants.COMPANIES_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.COMPANIES_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* companiesRefresh() {
  yield takeLatest(constants.COMPANIES_REFRESH.ACTION, fetchCompanies)
}

function* getAllCompanies(action) {
  try {
    const payload = yield call(api.getCompaniesList, action)
    yield put({ type: constants.GET_COMPANIES.SUCCESS, payload })
    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANIES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllCompanies() {
  yield takeLatest(constants.GET_COMPANIES.ACTION, getAllCompanies)
}

function* getAllCompaniesVendorClient(action) {
  try {
    const payload = yield call(api.getAllCompaniesVendorClient, action)
    yield put({ type: constants.GET_COMPANIES_VENDOR_CLIENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANIES_VENDOR_CLIENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllCompaniesVendorClient() {
  yield takeLatest(constants.GET_COMPANIES_VENDOR_CLIENTS.ACTION, getAllCompaniesVendorClient)
}

function* sagaCreateNewCompany(action) {
  try {
    const payload = {
      vendor_data: {
        type: 'Client',
        name: action.company.name,
        work_number: action.company.work_number,
        fax_number: action.company.fax_number,
        company: action.company.name,
        address1: action.company.address1,
        address2: action.company.address2,
        city: action.company.city,
        state: action.company.state,
        zip: action.company.zip
      },
      user_id: action.userId
    }

    yield call(api.createNewCompany, payload)
    yield put({ type: constants.CREATE_NEW_COMPANY.SUCCESS, payload })
    yield call(fetchCompanies, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_COMPANY.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNewCompany() {
  yield takeLatest(constants.CREATE_NEW_COMPANY.ACTION, sagaCreateNewCompany)
}

function* sagaUpdateSavedCompany(action) {
  try {
    const payload = {
      company: {
        category_id: action.company.categoryId,
        name: action.company.name,
        description: action.company.description,
        work_number: action.company.work_number,
        fax_number: action.company.fax_number,
        internal_description: action.company.internal_description,
        type: 'Client',
        cost: action.company.cost,
        overhead: action.company.overhead,
        markup: action.company.markup,
        tax: action.company.tax,
        created_by_id: action.userId,
        updated_by_id: action.userId
      },
      company_id: action.companyId
    }
    yield call(api.updateSavedCompany, payload)
    yield put({ type: constants.UPDATE_SAVED_COMPANY.SUCCESS, payload })
    yield call(fetchCompanies, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_SAVED_COMPANY.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateSavedCompany() {
  yield takeLatest(constants.UPDATE_SAVED_COMPANY.ACTION, sagaUpdateSavedCompany)
}

function* sagaDeleteCompany(action) {
  try {
    yield call(api.deleteCompany, { companyId: action.companyId })
    yield put({ type: constants.DELETE_COMPANY.SUCCESS })
    yield call(fetchCompanies)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_COMPANY.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteCompany() {
  yield takeLatest(constants.DELETE_COMPANY.ACTION, sagaDeleteCompany)
}

function* sagaGetCompanyLeads(action) {
  try {
    const companyLeads = yield call(api.getCompanyLeads, { companyId: action.companyId })
    yield put({ type: constants.GET_COMPANY_LEADS.SUCCESS, companyLeads })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANY_LEADS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetCompanyLeads() {
  yield takeLatest(constants.GET_COMPANY_LEADS.ACTION, sagaGetCompanyLeads)
}

function* sagaGetCompanyJobs(action) {
  try {
    const companyJobs = yield call(api.getCompanyJobs, { companyId: action.companyId })
    yield put({ type: constants.GET_COMPANY_JOBS.SUCCESS, companyJobs })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANY_JOBS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetCompanyJobs() {
  yield takeLatest(constants.GET_COMPANY_JOBS.ACTION, sagaGetCompanyJobs)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      companyId: action.companyId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_COMPANY_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_COMPANY_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_COMPANY_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.companyId)
    yield put({ type: constants.GET_COMPANY_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANY_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_COMPANY_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: action.userId,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_COMPANY_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { companyId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_COMPANY_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_COMPANY_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      companyId: action.companyId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_COMPANY_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { companyId: action.currentId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_COMPANY_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_COMPANY_ATTACHMENT.ACTION, deleteAttachment)
}

// notes
function* fetchCompanyNote(action) {
  try {
    const companyNotes = yield call(api.fetchCompanyNote, { companyId: action.companyId })
    yield put({ type: constants.GET_COMPANY_NOTE.SUCCESS, companyNotes })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_COMPANY_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchCompanyNote() {
  yield takeLatest(constants.GET_COMPANY_NOTE.ACTION, fetchCompanyNote)
}

function* createCompanyNote(action) {
  try {
    const payload = {
      content: action.content,
      companyId: action.companyId
    }
    yield call(api.createCompanyNote, payload)
    yield put({ type: constants.CREATE_COMPANY_NOTE.SUCCESS, payload })
    yield call(fetchCompanyNote, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_COMPANY_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateCompanyNote() {
  yield takeLatest(constants.CREATE_COMPANY_NOTE.ACTION, createCompanyNote)
}

function* editCompanyNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editCompanyNote, payload)
    yield put({ type: constants.EDIT_COMPANY_NOTE.SUCCESS, payload })
    yield call(fetchCompanyNote, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_COMPANY_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditCompanyNote() {
  yield takeLatest(constants.EDIT_COMPANY_NOTE.ACTION, editCompanyNote)
}

function* deleteCompanyNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteCompanyNote, payload)
    yield put({ type: constants.DELETE_COMPANY_NOTE.SUCCESS, payload })
    yield call(fetchCompanyNote, { companyId: action.companyId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_COMPANY_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteCompanyNote() {
  yield takeLatest(constants.DELETE_COMPANY_NOTE.ACTION, deleteCompanyNote)
}

export function* rootSaga() {
  yield all([
    fork(companiesRefresh),
    fork(watchCreateNewCompany),
    fork(watchUpdateSavedCompany),
    fork(watchDeleteCompany),
    fork(watchGetAllCompanies),
    fork(watchGetAllCompaniesVendorClient),

    fork(watchGetCompanyLeads),
    fork(watchGetCompanyJobs),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    //notes
    fork(watchFetchCompanyNote),
    fork(watchCreateCompanyNote),
    fork(watchEditCompanyNote),
    fork(watchDeleteCompanyNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/companiesSaga.js